import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PostLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const idToken = hashParams.get("id_token");
    const accessToken = hashParams.get("access_token");

    console.log("Extracted Tokens:");
    console.log("id_token:", idToken ? "[Present]" : "[Missing]");
    console.log("access_token:", accessToken ? "[Present]" : "[Missing]");
const awsSessionExists = document.cookie.includes("aws_session");

if (!awsSessionExists) {
  console.log("⚠️ No AWS Marketplace session detected, skipping link.");
  navigate("/");
  return;
}
    if (!idToken || !accessToken) {
      alert("Missing tokens");
      return;
    }

    sessionStorage.setItem("idToken", idToken);
    sessionStorage.setItem("accessToken", accessToken);
    localStorage.setItem("idToken", idToken);

    const userPayload = JSON.parse(atob(idToken.split(".")[1]));
    const cognitoUserId = userPayload.sub;

    console.log("Decoded Cognito User ID:", cognitoUserId);

    fetch("https://v1qtscizrb.execute-api.ap-southeast-2.amazonaws.com/prod/api/link-account", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      body: JSON.stringify({ cognitoUserId })
    })
      .then(res => {
        console.log("Response status:", res.status);
        return res.json();
      })
      .then(data => {
        console.log("Link result:", data);
        navigate("/");
      })
      .catch(err => {
        console.error("Linking failed:", err);
        alert("Error linking AWS subscription.");
        navigate("/");
      });
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <h4>Linking your AWS subscription...</h4>
    </div>
  );
};

export default PostLogin;
